import { render, staticRenderFns } from "./MunicipalityAddresses.vue?vue&type=template&id=50bdbc28&scoped=true"
import script from "./MunicipalityAddresses.vue?vue&type=script&lang=js"
export * from "./MunicipalityAddresses.vue?vue&type=script&lang=js"
import style0 from "./MunicipalityAddresses.vue?vue&type=style&index=0&id=50bdbc28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bdbc28",
  null
  
)

export default component.exports